import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

export interface INotificationTypeSettings {
    enabled: boolean;
    channels: {
        email: boolean;
        inApp: boolean;
        sms: boolean;
    };
}

export interface INotificationTypes {
    location_updates?: INotificationTypeSettings;
    status_changes?: INotificationTypeSettings;
    document_uploads?: INotificationTypeSettings;
    order_modifications?: INotificationTypeSettings;
}

export const saveNotificationSettings = async (params: { notificationTypes: INotificationTypes }) => {
    const response = await axiosInterceptor.post(API.CUSTOMER.NOTIFICATION_SETTINGS, params);

    return response;
};

// ── Tracking notification recipients pool (customer-wide, stored on customer_master).
// The order modal's dropdown offers this pool; "Create" in the dropdown saves here immediately. ──
export interface ITrackingNotificationRecipient {
    id: string;
    type: 'email' | 'phone';
    /** Email lowercased, phone in E.164 (e.g. +14163061172) */
    value: string;
    createdAt: string;
}

// Shared tracking link document toggles (cp-meeting-changes F3)
export type SharedLinkDocumentGroup = 'bol' | 'pod' | 'customerInvoice' | 'customsDocument' | 'otherDocument' | 'customerUpload';
export type SharedLinkDocumentSettings = Record<SharedLinkDocumentGroup, boolean>;

export const getSharedLinkDocumentSettings = async () => {
    const response = await axiosInterceptor.get(API.CUSTOMER.SHARED_LINK_DOCUMENTS);

    return response;
};

export const updateSharedLinkDocumentSettings = async (settings: SharedLinkDocumentSettings) => {
    const response = await axiosInterceptor.put(API.CUSTOMER.SHARED_LINK_DOCUMENTS, settings);

    return response;
};
